import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
import { getDefaultCompanyId } from 'utils/helpers';

interface DailyLimitTypes {
    dailyLimits: any;
    loading: boolean;
}
const initialState: DailyLimitTypes = {
    dailyLimits: null,
    loading: false,
};

export const fetchDailyLimits = createAsyncThunk('user/fetchDailyLimits', async (_, { getState }) => {
    const state: any = getState();
    const companyId = getDefaultCompanyId(state);
    const result: any = await client.get(`${oldGloryBaseUrl}/user/getDailyLimits`, {
        headers: {
            companyId,
        },
    });
    const { M2M_RECEIVE_LIMIT, LIMIT_START_TIME, M2P_SEND_LIMIT, M2M_SEND_LIMIT } = result || {};
    const { DAILY_LIMIT_RECEIVER_MONEYCONTAINER_MAXIMUM_AMOUNT, REMAINING_DAILY_LIMIT_RECEIVER_MONEYCONTAINER_MAXIMUM_AMOUNT } =
        M2M_RECEIVE_LIMIT || {};
    const { DAILY_LIMIT_SENDER_MONEYCONTAINER_MAXIMUM_AMOUNT, REMAINING_DAILY_LIMIT_SENDER_MONEYCONTAINER_MAXIMUM_AMOUNT } =
        M2P_SEND_LIMIT || {};

    const normalizedBalance = {
        dailyReceiveLimit: DAILY_LIMIT_RECEIVER_MONEYCONTAINER_MAXIMUM_AMOUNT,
        dailyRemainingReceiveLimit: REMAINING_DAILY_LIMIT_RECEIVER_MONEYCONTAINER_MAXIMUM_AMOUNT,
        dailyM2pSendLimit: DAILY_LIMIT_SENDER_MONEYCONTAINER_MAXIMUM_AMOUNT,
        dailyM2pRemainingSendLimit: REMAINING_DAILY_LIMIT_SENDER_MONEYCONTAINER_MAXIMUM_AMOUNT,
        dailyM2mSendLimit: M2M_SEND_LIMIT?.DAILY_LIMIT_SENDER_MONEYCONTAINER_MAXIMUM_AMOUNT,
        dailyM2mRemainingSendLimit: M2M_SEND_LIMIT?.REMAINING_DAILY_LIMIT_SENDER_MONEYCONTAINER_MAXIMUM_AMOUNT,
        LIMIT_START_TIME,
    };

    return normalizedBalance;
});

const dailyLimitSlice = createSlice({
    name: 'userSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDailyLimits.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchDailyLimits.fulfilled, (state, action) => {
            state.loading = false;
            state.dailyLimits = action.payload;
        });
        builder.addCase(fetchDailyLimits.rejected, (state) => {
            state.loading = false;
        });
    },
});
export default dailyLimitSlice.reducer;
